import * as React from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";
import { headCells } from "./Utils/TableHeadlist";
import { useSelector } from "react-redux";

function EnhancedTableHead() {
  const account = useSelector((state: any) => state.auth);

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => {
          // If you want to hide specific columns based on permission
          if (headCell.id === "ivf_status") {
            return null;
          }

          return (
            <TableCell
              key={headCell.id}
              align="left"
              className="fw-semibold text-nowrap"
              style={{
                backgroundColor: "#f8f9fa",
                fontWeight: 600,
                borderBottom: "2px solid #dee2e6",
              }}
            >
              {headCell.label}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}

export default React.memo(EnhancedTableHead);
